import VueI18n from "vue-i18n";
import { createI18n } from "../i18n";
import NewsDetailPage from "./NewsDetailPage.vue";

var Vue = window.mainVue;
if (Vue) {
  document.addEventListener("DOMContentLoaded", function () {
    var el = document.getElementById("newNewsDetailApp");
    if (!el) return;

    window.mainVue.use(VueI18n);

    var data = window.__NEWS_DETAIL_DATA__ || {};

    new Vue({
      i18n: createI18n(),
      render: function (h) {
        return h(NewsDetailPage, {
          props: {
            title: data.title || "",
            date: data.date || "",
            image: data.image || "",
            content: data.content || "",
            subNavItems: data.subNavItems || [],
          },
        });
      },
    }).$mount(el);
  });
}
